export const QueryKeys = {
  Profile: ['profile'],
  Policies: ['policies'],
  Invoices: ['invoices'],
  AdminPolicies: (customerUuid: string) => ['policies', customerUuid],
};
